import auditTrail from 'services/audit-trail'

export const AUDIT_LOG_EVENT = 'AUDIT_LOG_EVENT'

export const EVENT_ACTIONS = {
  jobAdApplyView: 'jobAdApplyView',
  jobAdListView: 'jobAdListView',
  jobAdView: 'jobAdView',
  jobAdQuickInterviewView: 'jobAdQuickInterviewView',
  jobAdSeeYouView: 'jobAdSeeYouView',
  jobAdThankYouView: 'jobAdThankYouView',
  linkedInApply: 'linkedInApply',
}

export const logEvent = params => (dispatch, getState) => {
  const state = getState()
  return auditTrail.trackEvent({
    ...params,
    ul: state.global.language,
  })
}
